import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/copy.svg'
import _imports_1 from '@/assets/icons/share.svg'
import _imports_2 from '@/assets/icons/download.svg'
import _imports_3 from '@/assets/icons/eye.svg'


const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "v1-code-card__icon" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "v1-code-card__glyph",
  "data-testid": "v1-code-card-glyph"
}
const _hoisted_5 = {
  key: 0,
  viewBox: "0 0 21 21",
  width: "20",
  height: "20",
  "aria-hidden": "true"
}
const _hoisted_6 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "20",
  height: "20",
  "aria-hidden": "true"
}
const _hoisted_7 = {
  class: "v1-code-card__title",
  "data-testid": "v1-code-card-title"
}
const _hoisted_8 = {
  key: 1,
  ref: "qrContainer",
  class: "v1-code-card__qr",
  "data-testid": "v1-code-card-qr"
}
const _hoisted_9 = {
  key: 4,
  class: "v1-code-card__actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_barCode = _resolveComponent("barCode")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "v1-code-card",
    "data-testid": _ctx.dataTestid
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.code.icon.kind === 'logo')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.code.icon.url,
            alt: _ctx.code.title || _ctx.code.label,
            class: "v1-code-card__logo",
            style: _normalizeStyle(_ctx.logoMaxHeight ? { maxHeight: _ctx.logoMaxHeight } : undefined),
            "data-testid": "v1-code-card-logo"
          }, null, 12, _hoisted_3))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, [
            (_ctx.code.icon.name === 'bank')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("path", {
                    fill: "currentColor",
                    d: "M18.6473 2.35266C18.4823 2.18772 18.2763 2.06976 18.0505 2.01093C17.8247 1.9521 17.5873 1.95453 17.3627 2.01797H17.3504L1.60535 6.79547C1.34974 6.86914 1.12254 7.01874 0.953875 7.22444C0.785206 7.43015 0.683026 7.68226 0.660876 7.94735C0.638726 8.21244 0.69765 8.47801 0.829842 8.70886C0.962033 8.9397 1.16125 9.12493 1.40109 9.24L8.36719 12.6328L11.7551 19.5948C11.8605 19.8197 12.028 20.0097 12.2379 20.1424C12.4478 20.2751 12.6913 20.345 12.9396 20.3437C12.9773 20.3437 13.0151 20.3421 13.0528 20.3388C13.3177 20.3174 13.5697 20.2154 13.775 20.0467C13.9802 19.8779 14.129 19.6504 14.2013 19.3946L18.9755 3.64957C18.9755 3.64547 18.9755 3.64137 18.9755 3.63727C19.0397 3.41329 19.0432 3.17625 18.9855 2.95048C18.9279 2.72472 18.8111 2.51838 18.6473 2.35266ZM12.947 19.0189L12.9429 19.0304V19.0247L9.65672 12.2735L13.5942 8.33602C13.7121 8.21194 13.7768 8.04673 13.7746 7.87561C13.7725 7.70448 13.7035 7.54098 13.5825 7.41997C13.4615 7.29896 13.298 7.23 13.1269 7.22781C12.9557 7.22562 12.7905 7.29037 12.6664 7.40824L8.72895 11.3457L1.97531 8.05957H1.96957H1.98105L17.7188 3.28125L12.947 19.0189Z"
                  }, null, -1)
                ]))]))
              : (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("path", {
                    fill: "currentColor",
                    d: "M3 5h2v14H3V5Zm3 0h1v14H6V5Zm2 0h2v14H8V5Zm3 0h1v14h-1V5Zm2 0h2v14h-2V5Zm3 0h1v14h-1V5Zm2 0h2v14h-2V5Z"
                  }, null, -1)
                ]))]))
          ]))
    ]),
    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.code.title || _ctx.code.label), 1),
    (_ctx.isBarcode)
      ? (_openBlock(), _createBlock(_component_barCode, {
          key: 0,
          value: _ctx.code.value,
          format: "CODE128",
          class: "v1-code-card__barcode",
          "display-value": false,
          background: "transparent",
          height: "48",
          "margin-top": "1",
          "margin-bottom": "1",
          "data-testid": "v1-code-card-barcode"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("barcode-not-created")), 1)
          ]),
          _: 1
        }, 8, ["value"]))
      : _createCommentVNode("", true),
    (_ctx.isQr)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_qrcode_vue, {
            value: _ctx.code.value,
            size: 180,
            level: "H",
            background: "transparent",
            "render-as": "svg"
          }, null, 8, ["value"])
        ], 512))
      : _createCommentVNode("", true),
    (_ctx.showValue)
      ? (_openBlock(), _createElementBlock("p", {
          key: 2,
          class: "v1-code-card__value",
          style: _normalizeStyle(_ctx.valueFontSize ? { fontSize: _ctx.valueFontSize } : undefined),
          "data-testid": "v1-code-card-value"
        }, _toDisplayString(_ctx.displayValue), 5))
      : _createCommentVNode("", true),
    (_ctx.code.caption)
      ? (_openBlock(), _createElementBlock("p", {
          key: 3,
          class: "v1-code-card__caption",
          style: _normalizeStyle(_ctx.captionFontSize ? { fontSize: _ctx.captionFontSize } : undefined),
          "data-testid": "v1-code-card-caption"
        }, _toDisplayString(_ctx.code.caption), 5))
      : _createCommentVNode("", true),
    (_ctx.hasActions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.showCopy)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                variant: "neutral-tonal",
                size: "lg",
                class: "v1-code-card__pill",
                "data-testid": "v1-code-card-copy",
                onClick: _ctx.copy
              }, {
                "icon-trailing": _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "",
                    "aria-hidden": "true",
                    class: "v1-code-card__pill-icon"
                  }, null, -1)
                ]))]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.copyLabel || (_ctx.qrImageCopy && _ctx.isQr ? _ctx.t("copy-qr") : _ctx.t("copy-code"))) + " ", 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.showShare && !_ctx.qrDownload)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                variant: "neutral-tonal",
                size: "lg",
                class: "v1-code-card__pill",
                "data-testid": "v1-code-card-share",
                onClick: _ctx.share
              }, {
                "icon-trailing": _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "",
                    "aria-hidden": "true",
                    class: "v1-code-card__pill-icon"
                  }, null, -1)
                ]))]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("share")) + " ", 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.qrDownload && _ctx.isQr)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                variant: "neutral-tonal",
                size: "lg",
                class: "v1-code-card__pill",
                "data-testid": "v1-code-card-download",
                onClick: _ctx.download
              }, {
                "icon-trailing": _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    alt: "",
                    "aria-hidden": "true",
                    class: "v1-code-card__pill-icon"
                  }, null, -1)
                ]))]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("download")) + " ", 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.invoice)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 3,
                variant: "neutral-tonal",
                size: "lg",
                class: "v1-code-card__pill",
                "data-testid": "v1-code-card-invoice",
                onClick: _ctx.openInvoice
              }, {
                "icon-trailing": _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("img", {
                    src: _imports_3,
                    alt: "",
                    "aria-hidden": "true",
                    class: "v1-code-card__pill-icon"
                  }, null, -1)
                ]))]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.invoice.label) + " ", 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}